import * as React from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';

export const Error = () => (
  <div id="root__error" className="sui-w-screen sui-h-screen sui-content-center">
    <div className="sui-grid sui-gap-1 sui-text-center">
      <div className="sui-mx-auto">
        <img src="https://assets.homedepot-static.com/images/v1/oops.svg" alt="" width="700" height="205" />
      </div>

      <div className="sui-flex sui-flex-col sui-gap-2 sui-mb-3">
        <Typography variant="h1" weight="display">
          WE&apos;RE FIXING IT.
        </Typography>
        <Typography variant="h3">We&apos;ll have this patched up as soon as possible</Typography>
      </div>

      <div>
        <Button href="/">Back to homepage</Button>
      </div>
    </div>
  </div>
);

Error.propTypes = {};

Error.defaultProps = {};
